import { Result, err, ok } from "neverthrow";
import { HttpContact, IContactParser } from "../lineInfoRepository.types";
import { Contact, IContact } from "@/domain/entities/lineInfo";
import { ParseError } from "@/repositories/shared/errors/parseError";
import { injectable } from "inversify";

@injectable()
export class ContactParser implements IContactParser {
  constructor() {}

  toDomain(data: HttpContact): Result<IContact, ParseError> {
    try {
      const contact: IContact = {
        serviceUid: data.serviceUid,
        name: data.name,
        officeNumber: data.officePhone,
        contactBeginHour: data.beginHour,
        contactBeginMin: data.beginMin,
        contactEndHour: data.endHour,
        contactEndMin: data.endMin,
        campusCode: data.campusCode,
        campusName: data.campusName,
      };
      return ok(new Contact(contact));
    } catch (error: any) {
      return err(new ParseError(error.message));
    }
  }
}
